app.controller('CIFHeadCtrl', ['$scope', '$window', '$q', 'appFactory',
    function ($scope, $window, $q, appFactory) {
    $scope.stepClass = ['','', '', '', ''];
    $scope.stepActive = 'active current';
    $scope.current = 0;

    var allPromise = $q.all([
        appFactory.postGetData(`service/client.svc/retrieveSession`, 'POST').then(function (data) {

            if (data.status == 200) {

                if (!data.data.d) {

                    $scope.signOut();
                }
                else
                    $scope.currentUser = data.data.d;
            }
        })
    ]);
    
    allPromise.then(function () {

        appFactory.getData(`service/client.svc/getCIF`).then(function (data) {

            if (data.status == 200) {

                if (data.data.d != null) {

                    var obj = data.data.d;
                    $scope.CIFInvestor = data.data.d;

                    if ($scope.CIFInvestor) {

                        if ($scope.CIFInvestor.Occupation == 1 || $scope.CIFInvestor.Occupation == 2) {

                            $scope.spouseMandatory = true;
                        }
                    }

                  
                }
            }
        })

        for(var i=1;i<5;i++)
        {
            if (i <= $scope.currentUser.Stage)
                $scope.stepClass[i] = 'done';
        }

        switch ($window.location.hash) {
            case "#/cif/data-pribadi": $scope.current = 1; $scope.stepClass[1] = $scope.stepActive; break;
            case "#/cif/data-pekerjaan": $scope.current = 2; $scope.stepClass[2] = $scope.stepActive; break;
            case "#/cif/data-benef": $scope.current = 3; $scope.stepClass[3] = $scope.stepActive; break;
            case "#/cif/data-pendukung": $scope.current = 4; $scope.stepClass[4] = $scope.stepActive; break;
            case "#/cif/data-pernyataan": $scope.current = 5; $scope.stepClass[5] = $scope.stepActive; break;
        }
    });


    $scope.showForm = function (goto) {
        if (goto <= $scope.currentUser.Stage)
        {
            let page = '#/cif/data-pribadi';

            switch (goto) {
                case 1: page = '#/cif/data-pribadi'; break;
                case 2: page = '#/cif/data-pekerjaan'; break;
                case 3: page = '#/cif/data-benef'; break;
                case 4: page = '#/cif/data-pendukung'; break;
                case 5: page = '#/cif/data-pernyataan'; break;
            }
            $window.location.href = page;
            $window.location.reload();
        }
    }
}]);